import React, { useEffect, useState, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { createColumnHelper, getCoreRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table'
import moment from 'moment'
import { useDispatch } from 'react-redux'

import styles from './styles.module.scss'

import { getMaintenanceRecords } from '../../../api'
import { showMaintenanceRecord } from '../../../store/asset/actions'

import Table from '../../Invoices/Table'
import { AttachmentIcon, PhotoIcon } from '../Icons'

const columnHelper = createColumnHelper()

const MaintenanceRecordsHistory = ({companyId}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [records, setRecords] = useState([])

  useEffect(() => {
    getHistory()
  }, [companyId])

  useEffect(() => {
    const handler = (event) => {
      getHistory()
    }
    window.addEventListener('maintenance-record-created', handler)
    return () => {
      window.removeEventListener('maintenance-record-created', handler)
    }
  }, [])

  const getHistory = async () => {
    const res = await getMaintenanceRecords(companyId)
    if (Array.isArray(res?.data)) {
      setRecords(res.data)
    }
  }

  const handleClickRow = (row) => {
    dispatch(showMaintenanceRecord(row))
  }

  const columns = useMemo(() => [
    columnHelper.accessor('date', {
      header: t('Date'),
      enableSorting: false,
      cell: ({getValue}) => moment(getValue()).format('YYYY-MM-DD')
    }),
    columnHelper.accessor('asset.name', {
      enableSorting: false,
      header: t('Asset'),
    }),
    columnHelper.accessor('maintenance_plan.name', {
      enableSorting: false,
      header: t('Maintenance plan'),
      cell: ({getValue}) => {
        return getValue() || t('Unplanned repair')
      }
    }),
    columnHelper.accessor('employee', {
      enableSorting: false,
      header: t('Performed by'),
      cell: ({getValue}) => {
        const employee = getValue()
        return `${employee.name} ${employee.surname || ''}`
      }
    }),
    columnHelper.accessor('supplier', {
      enableSorting: false,
      header: t('Supplier'),
    }),
    columnHelper.accessor('cost', {
      enableSorting: false,
      header: t('Cost'),
    }),
    columnHelper.accessor('notes', {
      enableSorting: false,
      header: t('Notes'),
    }),
    columnHelper.accessor('documents', {
      enableSorting: false,
      header: t('Files'),
      cell: ({getValue}) => {
        const documents = getValue()
        if (!Array.isArray(documents) || documents.length === 0) {
          return '-'
        }
        const { photos, attachments } = documents.reduce((acc, doc) => {
          return {
            ...acc,
            photos: acc.photos + (doc.type === 'photo' ? 1 : 0),
            attachments: acc.attachments + (doc.type === 'attachment' ? 1 : 0),
          }
        }, {photos: 0, attachments: 0})
        return (
          <div className={styles.documentsCell}>
            <AttachmentIcon /> {attachments} <PhotoIcon />{photos}
          </div>
        )
      }
    })
    ], [t])

  const table = useReactTable({
    data: records,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  })

  return (
    <div className={styles.container}>
      <Table
        table={table}
        columns={columns}
        onClickRow={handleClickRow}
        headerClassName={styles.tableHeader} />
    </div>
  )
}

export default MaintenanceRecordsHistory
